export interface RedactedCredentialRecord {
  recipientName?: string | null;
  recipientEmail?: string | null;
  versionNumber: number;
  reason?: string | null;
  status?: string | null;
  generatedBy?: string | null;
  generatedAt?: string | null;
  downloadCount: number;
  activatedAt?: string | null;
}

const escapePdf = (value: unknown) => String(value ?? "—")
  .replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)")
  .replace(/[^\x20-\x7E]/g, "?");

export function buildRedactedCredentialRecordPdf(record: RedactedCredentialRecord): Blob {
  const reason = (record.reason || "issued").replace(/_/g, " ");
  const status = (record.status || "unknown").replace(/_/g, " ");
  const lines = [
    "REDACTED CREDENTIAL ISSUANCE RECORD",
    "This is an audit record, not a usable login document.",
    `Recipient: ${record.recipientName || "—"}`,
    `Email: ${record.recipientEmail || "—"}`,
    `Document version: ${record.versionNumber}`,
    `Reason: ${reason}`,
    `Credential status: ${status}`,
    `Generated by: ${record.generatedBy || "—"}`,
    `Generated at: ${record.generatedAt || "—"}`,
    `Recorded downloads: ${record.downloadCount}`,
    `Activated at: ${record.activatedAt || "—"}`,
    "Temporary password: [REDACTED - NEVER STORED]",
    "To issue usable instructions, generate a new temporary login.",
  ];
  const stream = ["BT", "/F1 18 Tf", "54 744 Td", `(${escapePdf(lines[0])}) Tj`, "/F1 10 Tf"];
  lines.slice(1).forEach((line, index) => stream.push(`0 ${index === 0 ? -28 : -24} Td (${escapePdf(line)}) Tj`));
  stream.push("ET");
  const body = stream.join("\n");
  const objects = [
    "<< /Type /Catalog /Pages 2 0 R >>",
    "<< /Type /Pages /Kids [3 0 R] /Count 1 >>",
    "<< /Type /Page /Parent 2 0 R /MediaBox [0 0 612 792] /Resources << /Font << /F1 5 0 R >> >> /Contents 4 0 R >>",
    `<< /Length ${body.length} >>\nstream\n${body}\nendstream`,
    "<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>",
  ];
  let pdf = "%PDF-1.4\n";
  const offsets = [0];
  objects.forEach((object, index) => { offsets.push(pdf.length); pdf += `${index + 1} 0 obj\n${object}\nendobj\n`; });
  const xref = pdf.length;
  pdf += `xref\n0 ${objects.length + 1}\n0000000000 65535 f \n`;
  offsets.slice(1).forEach((offset) => { pdf += `${String(offset).padStart(10, "0")} 00000 n \n`; });
  pdf += `trailer\n<< /Size ${objects.length + 1} /Root 1 0 R >>\nstartxref\n${xref}\n%%EOF`;
  return new Blob([pdf], { type: "application/pdf" });
}
